module.exports = __webpack_public_path__ + "static/img/en.522cd947.png";